import { React, useEffect, useCallback, useState } from "react";
import Address from "../components/Address";
import { useForm } from "react-hook-form";
import { useNavigate,useLocation } from "react-router-dom";
import { Row, Col, Container, Spinner } from 'react-bootstrap';
import Header from "../components/Header";
import BottomNavBar from "../components/BottomNavBar";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import BlockHeading from "../components/BlockHeading";
import SATextArea from "../components/SATextArea";
import FullName from "../components/FullName";
import SATextInput from "../components/SATextInput";
import ContactInformation from "../components/ContactInformation"; 
import DateComponent from "../components/DateComponents";
import moment from 'moment';
import toast, { toastConfig } from 'react-simple-toasts';
import * as yourInfoAPI from "../services/yourInfoServices";

export default function YourInfo() {
    const navigate = useNavigate();
    const location = useLocation();

    const [loader, setLoader] = useState(false);
    const [studHCode, setHexCode] = useState('');

    toastConfig({
        render: message => <div style={{ backgroundColor: '#cc2427', color: 'white', padding: 10, borderRadius: 10, fontSize: 18, fontWeight: '700' }}>{message}</div>,
    })

    useEffect(() => {
        document.title = 'Scholarship Application | Families of WWII Vetearnas';
        window.scrollTo({ top: 0, behaviour: "smooth" })
    }, []);

    useEffect(() => {
       let hexCode =location?.state?.hexCode? location.state.hexCode : "";
       setHexCode(hexCode)
    }, [location?.state?.hexCode]);
    

    const { reset, register, handleSubmit, control, formState: { errors }} = useForm({
        defaultValues:{
            "studentId": 1,
            "studentHexCode": "",
            "firstName": "",
            "lastName": "",
            "middleName": "",
            "dateOfBirth": "",
            "ssn": "",
            "address1": "",
            "address2": "",
            "city": "",
            "state": "",
            "zipCode": "",
            "homePhone": "",
            "cellPhone": "",
            "emailAddress": "",
            "howDidYouHear": ""
        }
    });

    const getStudentInformationApi = useCallback(async () => {
        setLoader(true)
        try {
            await yourInfoAPI.getStudentInformation(`${studHCode}/your-info`).then((res) => {
                setLoader(false)
                if (res.status === 200) {
                    let studentInfoData = res.data;
                    let homeNumber = studentInfoData.homePhone;
                    let cellNumber = studentInfoData.cellNumber;

                   let homePhone = studentInfoData.homePhone  ? "(" + homeNumber.slice(0, 3) + ")" + homeNumber.slice(3, 6) + "-" + homeNumber.slice(6, 10): '';
                   let cellPhone = studentInfoData.cellNumber ? "(" + cellNumber.slice(0, 3) + ")" + cellNumber.slice(3, 6) + "-" + cellNumber.slice(6, 10) : "";
                    reset({
                        "firstName": studentInfoData.firstName,
                        "lastName": studentInfoData.lastName,
                        "middleName": studentInfoData.middleName,
                        "dateOfBirth": moment(studentInfoData.dateOfBirth).format('MM/DD/YYYY'),
                        "ssn": studentInfoData.last4ofSSN,
                        "address1": studentInfoData.streetAddress,
                        "address2": studentInfoData.address2,
                        "city": studentInfoData.city,
                        "state": studentInfoData.stateCode,
                        "zipCode": studentInfoData.zipCode,
                        "homePhone": homePhone,
                        "cellPhone": cellPhone,
                        "emailAddress": studentInfoData.emailAddress,
                        "howDidYouHear": studentInfoData.wayOfReach
                    })
                } else {
                    if(res.status === 204){
                        return 
                    }
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                }
            })
                .catch(function (error) {
                    setLoader(false)
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                    return error
                });
        }
        catch (error) {
            setLoader(false)
            toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
            return error
        }

    }, [studHCode,reset])

    useEffect(() => {
        if (studHCode) {
            console.log("get current education")
            getStudentInformationApi()
        }
    }, [getStudentInformationApi,studHCode]);

    const onSubmit = async (data) => {

        let studInfoObj = {
            "lastName": data.lastName,
            "firstName": data.firstName,
            "middleName": data.middleName,
            "dateOfBirth": moment(data.dateOfBirth).format('YYYY-MM-DD'),
            "last4ofSSN": data.ssn,
            "streetAddress": data.address1,
            "address2": data.address2,
            "city": data.city,
            "stateCode": data.state,
            "zipCode": data.zipCode,
            "homePhone": data.homePhone ? data.homePhone.toString().replace(/[^a-zA-Z0-9 ]/g, '') : '',
            "cellNumber": data.cellPhone.toString().replace(/[^a-zA-Z0-9 ]/g, ''),
            "emailAddress": data.emailAddress,
            "wayOfReach": data.howDidYouHear
        }

        setLoader(true)
        try {
            await yourInfoAPI.postStudentInformation(studInfoObj)
            
                .then((res) => {
                    setLoader(false)
                    if (res.status === 200) {
                        navigate("/current-education",{
                            state:{hexCode : res.data}
                        })
                    } else if (res.status === 422) {
                        let errorData = res?.data?.errors
                        if (Object.keys(errorData) && Object.keys(errorData).length > 0) {
                            Object.keys(errorData).forEach((err) => {
                                toast(errorData[err][0], { position: 'top-right', backgroundColor: 'red' })
                                return ""
                            })
                        }
                    } else {
                        toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                    }
                })
                .catch(function (error) {
                    setLoader(false)
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                    return error
                });
        }
        catch (error) {
            setLoader(false)
            toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
           
        }
    }

    return (
        <>
            <Header title="Scholarship Application" />
            {loader && <div lg={12} md={12} sm={12} className="loaderContainer">
                <Spinner animation="border" variant="primary" /> </div>}
            <Container className='py-3 py-md-4 py-md-5'>
                <Row>
                    <Col lg={12}>
                        <Nav navbType="student" />

                        <form onSubmit={handleSubmit(onSubmit)}>
                            <BlockHeading title="Your Information" />
                            <FullName
                                register={register}
                                errors={errors}
                                htmlForLastName={"lastName"}
                                nameLastName={"lastName"}
                                lastNameId={"lastNameHelp"}
                                lastNameErrMsg={errors.lastName?.message}
                                htmlForFirstName={"firstName"}
                                nameFirstName={"firstName"}
                                firstNameId={"firstNameHelp"}
                                firstNameErrMsg={errors.firstName?.message}
                                htmlForMiddleName={"middleName"}
                                nameMiddleName={"middleName"}
                                notReq={true}
                            />

                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="form-group">
                                        <DateComponent
                                            label={"Date of Birth:"}
                                            control={control}
                                            htmlFor={"dateOfBirth"}
                                            name={"dateOfBirth"}
                                            isStrong={true}
                                            required={"Date of Birth is required!"}
                                            invalidMessage={"Invalid Date of Birth!"}
                                            placeholder={"Date of Birth: mm/dd/yyyy"}
                                            id={"dobHelp"}
                                            errMsg={errors.dateOfBirth?.message}
                                        />
                                    </div>
                                </div>

                                <div className="col-lg-4">
                                    <SATextInput
                                        register={register}
                                        htmlFor={"ssn"}
                                        maxLength={4}
                                        name={"ssn"}
                                        label={"Last 4 of SSN:"}
                                        isStrong={true}
                                        requiredText={"Last 4 of SSN required!"}
                                        type={"password"}
                                        placeholder={"Last 4 of SSN"}
                                        errors={errors}
                                        id={"ssnHelp"}
                                        errMsg={errors.ssn?.message}
                                        requiredObj={{
                                            required: "Last 4 of SSN required!",
                                            pattern: { value: /^[0-9]{4}$/, message: "Invalid Last 4 of SSN!" }
                                        }}
                                    />
                                </div>
                            </div>
                            <hr />
                            <BlockHeading title="Your Permanent Address" />
                            <Address
                                register={register}
                                errors={errors}
                                htmlForAddress1={"address1"}
                                address1Name={"address1"}
                                addressId={"address1Help"}
                                errMsg={errors.address1?.message}
                                htmlForAddress2={"address2"}
                                address2Name={"address2"}
                                htmlForCity={"city"}
                                cityName={"city"}
                                cityId={"cityHelp"}
                                cityErrMsg={errors.city?.message}
                                htmlForState={"stateHtmlFor"}
                                stateName={"state"}
                                stateId={"stateHelp"}
                                stateErrMsg={errors.state?.message}
                                htmlForZipCode={"zipCode"}
                                zipCodeName={"zipCode"}
                                zipCodeErrMsg={errors.zipCode?.message}
                                zipcodeId={"ZipCodeHelp"}
                                notReq={true}
                            />
                            <hr />
                            <BlockHeading title="Contact Information" />

                            <ContactInformation
                                register={register}
                                errors={errors}
                                control={control}
                                htmlForHomePhone={"homePhone"}
                                homePhoneName={"homePhone"}
                                homePhoneId={"homePhoneHelp"}
                                homePhoneErrMsg={errors.homePhone?.message}
                                htmlForCellNumber={"cellNumber"}
                                cellPhoneName={"cellPhone"}
                                cellPhoneId={"cellPhoneHelp"}
                                cellPhoneErrMsg={errors.cellPhone?.message}
                                htmlForEmailAddress={"emailAddress"}
                                emailAddressName={"emailAddress"}
                                emailAddressId={"emailAddressHelp"}
                                emailAddressErrMsg={errors.emailAddress?.message}
                           
                            />
                            <hr />
                            <Row>
                                <Col lg={12}>
                                    <SATextArea
                                        register={register}
                                        htmlFor={"howDidYouHear"}
                                        name={"howDidYouHear"}
                                        label={"How did you hear about us?:"}
                                        isStrong={true}
                                        requiredObj={{ required: "How did you hear about us is required!", maxLength: { value: 400, message: "Max length is 400 characters!" } }}
                                        placeholder={"How did you hear about us? (required)"}
                                        maxLength={64}
                                        id={"howDidYouHearHelp"}
                                        errMsg={errors.howDidYouHear?.message}
                                    />
                                </Col>
                            </Row>
                            <BottomNavBar
                                submitButtonTitle="NEXT" />
                        </form >
                    </Col>
                </Row>
            </Container>
            <Footer />
        </>

    );
};

